import Icon, { IconProps } from './Icon';

import ArrowRightIcon from '../../../assets/icons/arrow-right.svg?react';

const ArrowRight: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <ArrowRightIcon />
    </Icon>
  );
};

export default ArrowRight;
